<template>
  <div class="overview-application-container p-1">
    <!-- Floating Tabs -->
    <div class="overview-tabs-wrapper overview-scrollable-container">
      <div class="overview-vertical-tabs-container">
        <div
          v-for="tab in tabs"
          :key="tab.id"
          class="overview-floating-tab rounded-lg"
          :class="{ active: active_tab === tab.id }"
          @click="select_tab(tab.id)"
        >
          <div class="overview-floating-tab-inner">
            <i class="me-2 fs-6" :class="tab.icon"></i>

            <span class="text-xs">{{ tab.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Dropdown / Accordion -->
    <div
      class="ms-2 overview-dropdown-column rounded-lg glassy-bg"
      v-if="active_tab_has_dropdown"
    >
      <div class="overview-accordion-container mb-3 border-0 rounded-lg">
        <div
          v-for="option in active_dropdown_options"
          :key="option.value"
          class="accordion-item bg-transparent"
        >
          <h2 class="accordion-header border-0">
            <div class="d-flex align-items-center w-100  rounded text-xxs bg-secondary-dark">
     
            </div>
          </h2>

          <div class="collapse" :class="{ show: selected_dropdown === option.value }">
            <div class="accordion-body">
              <!--  Slot for Compliance Content -->
              <slot
                name="content"
                :tab="active_tab"
                :section="option.value"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComplianceTabs",
  props: {
    tabs: { type: Array, required: true },
    dropdownOptions: { type: Object, required: true },
  },
  data() {
    return {
      active_tab: this.tabs[0]?.id || null,
      selected_dropdown: null,
    };
  },
  computed: {
    active_dropdown_options() {
      return this.dropdownOptions[this.active_tab] || [];
    },
    active_tab_has_dropdown() {
      const tab = this.tabs.find(t => t.id === this.active_tab);
      return tab?.has_dropdown ?? true;
    },
  },
  methods: {
    select_tab(tabId) {
      this.active_tab = tabId;
      const opts = this.dropdownOptions[tabId];
      this.selected_dropdown = opts?.[0]?.value || null;
    },
    toggle_dropdown(val) {
      this.selected_dropdown =
        this.selected_dropdown === val ? null : val;
    },
  },
  mounted() {
    const opts = this.dropdownOptions[this.active_tab];
    this.selected_dropdown = opts?.[0]?.value || null;
  },
};
</script>
